/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Model33 } from './model33';


export interface MerchantCategoryCreateInput { 
    archived?: boolean;
    createdAt?: string;
    id?: string;
    locked?: boolean;
    path?: string;
    published?: boolean;
    readOnly?: boolean;
    sortOrder?: number;
    subcategories?: Model33;
    title?: string;
    updatedAt?: string;
    version?: number;
}
